import React from "react";
import { Formik, FormikProps, FormikActions, FieldProps, Field } from "formik";
import * as Yup from "yup";
import { Values } from "Tools/Values";
import { inject, observer } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "@src/Stores/Management/types";
import { TextField } from "@material-ui/core";
import { required } from "@src/Tools/FormValidations";
import { STFormWrapper } from "./styles";

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .required(() => {
      return Values.getLocalizationValue("fieldRequired");
    })
    .email(() => {
      return Values.getLocalizationValue("invalidEmail");
    }),
  username: Yup.string().required(() => {
    return Values.getLocalizationValue("fieldRequired");
  }),
});

interface IProps {
  onSubmit: (values: IForgotPasswordForm, formikActions: FormikActions<IForgotPasswordForm>) => void;
  values?: IValuesStore;
  management?: IManagementStore;
}

export interface IForgotPasswordForm {
  username: string;
  email: string;
}

@inject("values", "management")
@observer
class ForgotPasswordForm extends React.Component<IProps> {
  render() {
    const username = sessionStorage.getItem("InvalidCredentials");
    return (
      <Formik
        initialValues={{ username: username || "", email: "" }}
        validationSchema={forgotPasswordSchema}
        onSubmit={this.props.onSubmit}
        render={(formikProps: FormikProps<IForgotPasswordForm>) => (
          <STFormWrapper onSubmit={formikProps.handleSubmit}>
            {!username && (
              <Field
                name={"username"}
                validate={required}
                render={({ field }: FieldProps) => (
                  <TextField
                    {...field}
                    fullWidth
                    style={{ marginBottom: "8px" }}
                    label={Values.getLocalizationValue("username")}
                    error={formikProps.touched.username && !!formikProps.errors.username}
                    helperText={formikProps.touched.username && formikProps.errors.username}
                    inputProps={{
                      autoCapitalize: "off",
                      autoCorrect: "off",
                    }}
                  />
                )}
              />
            )}

            <Field
              name={"email"}
              validate={required}
              render={({ field }: FieldProps) => (
                <TextField
                  {...field}
                  fullWidth
                  label={Values.getLocalizationValue("associatedMailAccount")}
                  error={formikProps.touched.email && !!formikProps.errors.email}
                  helperText={formikProps.touched.email && formikProps.errors.email}
                  inputProps={{
                    autoCapitalize: "off",
                    autoCorrect: "off",
                  }}
                />
              )}
            />

            {this.props.children}
          </STFormWrapper>
        )}
      />
    );
  }
}

export default ForgotPasswordForm;
